import { render } from "./TopTrend.vue?vue&type=template&id=03b18a1f"
import script from "./TopTrend.vue?vue&type=script&lang=js"
export * from "./TopTrend.vue?vue&type=script&lang=js"
script.render = render

export default script